<template>
  <div>
    <div>
      <div class="row mt-3">
        <CCol sm="6" md="3">
          <label for>Search</label>
          <div class="search-div position-relative">
            <input
              class="form-control"
              placeholder="Search"
              @input="debounceSearch()"
              v-model="search"
            />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
            <!-- <div @click="removeText()" v-if="searchText">
              <crossSolidSVG />
            </div>
            <div v-else>
              <searchSVG />
            </div>-->
          </div>
        </CCol>
        <CCol sm="6" md="3" class="datepicker pos-r">
          <label for>Date Range</label>
          <datepicker
            v-model="joinOnDateRange"
            @input="dateChange()"
            ref="datepicker"
            :model-config="datePickerConfig"
            :max-date="new Date()"
            is-range
            :masks="{ input: 'DD/MM/YYYY' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control pos-r"
                placeholder="DD/MM/YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetJoiningDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </CCol>
        <CCol sm="6" md="3">
          <div class="position-relative">
            <label for>Status</label>
            <select @change="changeStatus()" name id class="form-control" v-model="status">
              <option value="ALL">All</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Unpublished</option>
              <option value="REJECT">No Action</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </CCol>
      </div>
      <div class="col-sm-12 pl-0 pr-0 mt-5">
        <div class="table-div overflow-auto">
          <table class="table userlistTable">
            <thead>
              <tr class="table-success">
                <!--1-->
                <th>Blog title</th>

                <!--2-->
                <th>Writer's Name</th>

                <!--3-->
                <th>Writer' Role</th>

                <!--4-->
                <th>Published on</th>

                <!--5-->
                <th>Reported By</th>

                <!--6-->
                <th>Reporter's Role</th>

                <!--7-->
                <th>Status</th>

                <!--8-->
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="blogReportList.length > 0">
              <!-- 1st row -->
              <tr v-for="(report, i) in blogReportList" :key="i">
                <!-- Blog title -->
                <td class="text-capitalize">
                  {{
                  report.against_to_blog.title
                  ? report.against_to_blog.title
                  : "&#8213;"
                  }}
                </td>

                <!-- Writer's Name -->
                <td>
                  {{
                  report &&
                  report.against_to_blog &&
                  report.against_to_blog.user_id &&
                  report.against_to_blog.user_id.full_name
                  ? report.against_to_blog.user_id.full_name
                  : "&#8213;"
                  }}
                </td>

                <!-- Writer' Role -->
                <td class="text-capitalize">
                  {{
                  report &&
                  report.against_to_blog &&
                  report.against_to_blog.role
                  ? report.against_to_blog.role
                  : "&#8213;"
                  }}
                </td>

                <!-- Published on -->
                <td>{{ getDate(report.blog_update) }}</td>

                <!-- Reported By -->
                <td>
                  {{
                  report.raised_by.full_name
                  ? report.raised_by.full_name
                  : "&#8213;"
                  }}
                </td>

                <!-- Reporter's Role -->
                <td class="capitalize-text">
                  {{
                  report.raised_by_role ? report.raised_by_role : "&#8213;"
                  }}
                </td>

                <!-- Status -->
                <td>
                  <span v-if="report.inappropriate_status === 'REJECT'">NO ACTION</span>
                  <span v-else-if="report.inappropriate_status === 'APPROVED'">UNPUBLISHED</span>
                  <span v-else>{{ report.inappropriate_status }}</span>
                </td>

                <!-- Action -->
                <td>
                  <div class="action-div small-table-padding">
                    <div>
                      <CDropdown
                        v-if="report.inappropriate_status !== 'REJECT'"
                        color="link"
                        size="lg"
                        :caret="false"
                        class="dropdowndocbox"
                      >
                        <template #toggler-content>
                          <verticalDotsSVG />
                        </template>

                        <div v-if="permissions.includes('CAN_REJECT_USER_BLOGS')">
                          <CDropdownItem
                            v-if="report.inappropriate_status === 'PENDING'"
                            @click="openRejectModal(report, 'reject')"
                          >No Action</CDropdownItem>
                        </div>

                        <div
                          v-if="
                            permissions.includes('CAN_UNPUBLISH_USER_BLOGS')
                          "
                        >
                          <CDropdownItem
                            v-if="report.inappropriate_status === 'PENDING'"
                            @click="openRejectModal(report, 'approved')"
                          >Unpublish</CDropdownItem>
                        </div>

                        <div
                          v-if="
                            report.inappropriate_status === 'APPROVED' ||
                            report.inappropriate_status === 'PENDING'
                          "
                        >
                          <CDropdownItem @click="openReasonModal(report.description)">Reason</CDropdownItem>
                        </div>
                      </CDropdown>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <CModal
            :show.sync="reasonModal"
            :no-close-on-backdrop="true"
            :centered="true"
            title="Reason"
            color="dark"
          >
            <div class="col-sm-12">
              <h6>
                <!-- <p>{{ rejected_reason }}</p> -->
              </h6>
              <input type="text" />
            </div>
            <template #footer>
              <CButton color="danger" @click="reasonModal = false">Close</CButton>
            </template>
          </CModal>
        </div>
      </div>
    </div>
    <div v-if="showLoader && blogReportList.length === 0">
      <loader v-if="showLoader"></loader>
    </div>
    <div v-if="isEmpty">
      <h2 class="text-center">No Data Found</h2>
    </div>
    <pagination
      class="pagination-block"
      v-if="blogReportList.length > 0"
      :recordPerPage="recordPerPage"
      :currentPage="currentPage"
      :total="total"
      @changePage="changePage"
    />

    <!-- reason modal start -->
    <CModal
      :show.sync="reasonModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Reason"
      color="dark"
    >
      <div class="col-sm-12">
        <h6>{{ reject_reason }}</h6>
      </div>
      <template #footer>
        <CButton color="danger" @click="reasonModal = false">Cancel</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonText"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />

      <span v-if="showError" class="text-danger">This field is required</span>

      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
        <!-- <CButtonClose @click="rejectModal = false" class="text-white" /> -->
      </template>

      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="submit()">Submit</v-btn>
      </template>
    </CModal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import "@/assets/scss/_blogs.scss";
const loader = () => import("@/components/loader.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  components: {
    loader,
    pagination: () => import("@/views/common/Pagination"),
    Datepicker,
    ...pickSvg("crossSVG", "verticalDotsSVG")
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      showLoader: false,
      currentPage: 1,
      totalPage: 1,
      total: 0,
      role: "blog",
      recordPerPage: 10,
      status: "ALL",
      blogReportList: [],
      reasonModal: false,
      isEmpty: false,
      dayJS,
      reject_reason: "",
      search: "",
      joinOnDateRange: { start: "", end: "" },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      rejectModal: false,
      reportData: {},
      currentStatus: "",
      reasonText: "",
      showError: false
    };
  },

  mounted() {
    this.getReportInappropriate();
  },

  methods: {
    changeStatus() {
      this.getReportInappropriate();
    },

    dateChange() {
      this.getReportInappropriate();
    },
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.getReportInappropriate();
    },

    openReasonModal(reason) {
      this.reasonModal = true;
      this.reject_reason = reason;
    },

    openRejectModal(data, status) {
      this.currentStatus = status;
      this.reportData = data;
      if (this.currentStatus === "reject") {
        Swal.fire({
          title: "Are you sure you want to No Action on this blog",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.acceptAndReject();
          }
        });
      } else {
        this.rejectModal = true;
      }
    },

    changePage(page) {
      this.currentPage = page.currentPage;
      this.getReportInappropriate();
    },
    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },

    getReportInappropriate() {
      this.showLoader = true;
      this.total = 0;
      let url = `${config.BASE_URL}api/v2/admin/ticket/inappropriate`;
      let params = {
        against_to_role: this.role,
        page: this.currentPage,
        record_per_page: this.recordPerPage,
        status: this.status,
        search_text: this.search,
        start_date: this.joinOnDateRange.start.toString(),
        end_date: this.joinOnDateRange.end.toString()
      };
      this.$http.post(url, params).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.data.list.length) {
            this.blogReportList = response.body.data.data.list;
            this.totalPage =
              response.body.data.data.total_records / this.recordPerPage;
            if (
              response.body.data.data.total_records % this.recordPerPage !==
              0
            )
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.data.total_records;
          } else {
            this.blogReportList = [];
            this.isEmpty = true;
          }
        }
      });
    },

    debounceSearch: debounce(function() {
      this.getReportInappropriate();
    }, 500),

    acceptAndReject() {
      let url = `${config.BASE_URL}api/v2/admin/report-inappropriate/blog/${this.reportData._id}/${this.currentStatus}`;
      let obj = {
        reason: this.reasonText
      };
      this.$http.put(url, obj).then(response => {
        if (response.body.status) {
          this.rejectModal = false;
          Swal.fire({
            title: response.body.message,
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.getReportInappropriate();
            }
          });
        }
      });
    },

    submit() {
      this.reasonValidation(this.reasonText);
      if (!this.showError) {
        this.acceptAndReject();
      }
    },

    reasonValidation(newValue) {
      if (newValue === "") {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    clearSearch() {
      this.search = "";
    }
  },

  watch: {
    reasonText: function(newValue) {
      this.reasonValidation(newValue);
    }
  }
};
</script>